module.exports = "https://cdn-shared.mathletics.com/teacher-modules/upf-assign/68/assets/images/9e1d37b17a249a9ee1154ad4470ae939.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/ico_question_blank.svg
// module id = g1H5
// module chunks = 0